import { connect } from "react-redux";
import { Card, CardBody, Col, Container, Row, Spinner } from "reactstrap";
import { Helmet } from "react-helmet-async";
import CustomDatatable from "../../components/CustomDatatable/CustomDatatable";
import { useEffect, useState } from "react";
import "../../assets/scss/_commomAdminPages.scss";
import FilterAdmin from "../../components/FilterAdmin/FilterAdmin";
import renderFormatedDate from "../../components/RenderCellsDatatable/renderFormatterDate";
import {
  changePageSizeBusiness,
  cleanMessageBusiness,
  getListaBusiness,
  loadEmptyBusiness,
} from "../../store/actions";
import { useIsFirstRender } from "../../customHooks/useIsFirstRender";
import renderHeader from "../../components/RenderCellsDatatable/renderHeader";
import renderBoolean from "../../components/RenderCellsDatatable/renderBoolean";
import { useNavigate } from "react-router-dom";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { useContextActions } from "../../customHooks/useContextActions";
import ActionButtons from "../../components/ActionButtons/ActionButtons";
import { PAGE_SIZE_OPTIONS } from "../../constants/pagination";

const BusinessList = ({
  getListaBusinessRequest,
  loadingBusiness,
  listaBusiness,
  pageSizeBusiness,
  changePageSizeBusiness,
  loadEmptyBusiness,
  messageBusiness,
  cleanMessageBusiness,
}) => {
  const isFistRender = useIsFirstRender();
  const navigate = useNavigate();

  const [objFilter, setObjFilter] = useState({
    createDateStart: null,
    updateDateStart: null,
    createDateEnd: null,
    updateDateEnd: null,
    createUser: null,
    updateUser: null,
    status: true,
  });

  const [paginationModel, setPaginationModel] = useState({
    pageSize: pageSizeBusiness,
    page: 0,
  });

  const alertModal = withReactContent(Swal);

  const handlePageChange = (model) => {
    const { page, pageSize } = model;
    setPaginationModel({
      pageSize: pageSize,
      page: page,
    });

    changePageSizeBusiness(pageSize);

    getListaBusinessRequest({
      pageNumber: page + 1,
      pageSize: pageSize,
      createDateStart: objFilter.createDateStart,
      updateDateStart: objFilter.updateDateStart,
      createDateEnd: objFilter.createDateEnd,
      updateDateEnd: objFilter.updateDateEnd,
      createUser: objFilter.createUser,
      updateUser: objFilter.updateUser,
      status: objFilter.status,
      name: objFilter.search,
    });
  };

  const handleSortChange = (model) => {
    console.log(model);
    setTimeout(() => {
      //
    }, 300);
  };

  const handleRowClick = (params, event) => {
    navigate(`/business?id=${params.id}`);
  };

  const actions = useContextActions({ 
    context: "business", 
    screen: "list" 
  });

  useEffect(() => {
    if (isFistRender) {
      loadEmptyBusiness();
    }

    setPaginationModel((prev) => ({
      ...prev,
      page: 0,
    }));

    getListaBusinessRequest({
      pageNumber: 1,
      pageSize: paginationModel.pageSize,
      createDateStart: objFilter.createDateStart,
      updateDateStart: objFilter.updateDateStart,
      createDateEnd: objFilter.createDateEnd,
      updateDateEnd: objFilter.updateDateEnd,
      createUser: objFilter.createUser,
      updateUser: objFilter.updateUser,
      status: objFilter.status,
      name: objFilter.search,
    });

    // eslint-disable-next-line
  }, [objFilter]);

  useEffect(() => {
    if (messageBusiness) {
      alertModal
        .fire({
          title: `${
            messageBusiness !== null
              ? messageBusiness
              : "Something wrong, try again later."
          }`,
          icon: "error",
          showConfirmButton: false,
          timer: undefined,
          showCloseButton: true,
          timerProgressBar: false,
        })
        .then(() => {
          cleanMessageBusiness();
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messageBusiness]);

  useEffect(() => {
    return () => {
      cleanMessageBusiness();
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="page-content">
      <Helmet>
        <title>Business</title>
      </Helmet>
      <div></div>
      <Container fluid>
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <div>
                  <Row>
                    <div className="d-flex justify-content-between my-2">
                      <h2>BUSINESS</h2>
                      <ActionButtons 
                        actions={actions}
                        context="business"
                        handlers={{
                          create: () => navigate("/business"),
                        }}
                      />
                    </div>
                  </Row>
                  <FilterAdmin
                    setObjFilter={setObjFilter}
                    placeholderSearch={"Search by business"}
                    isFistRender={isFistRender}
                  />
                  <Row className="my-2">
                    {loadingBusiness ? (
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{ height: "400px", width: "100%" }}
                      >
                        <Spinner
                          color="primary"
                          style={{ height: "5rem", width: "5rem" }}
                        />
                      </div>
                    ) : (
                      <>
                        <CustomDatatable
                          columns={columns}
                          rows={listaBusiness.records}
                          rowCount={listaBusiness.totalRecords}
                          pagination
                          paginationMode="server"
                          paginationModel={paginationModel}
                          onPaginationModelChange={handlePageChange}
                          onSortModelChange={handleSortChange}
                          onRowClick={handleRowClick}
                          pageSizeOptions={PAGE_SIZE_OPTIONS}
                          checkboxSelection={false}
                          disableColumnFilter
                          disableColumnMenu
                        />
                      </>
                    )}
                  </Row>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const mapStateToProps = ({
  BusinessReducer: {
    loadingBusiness,
    listaBusiness,
    pageSizeBusiness,
    messageBusiness,
  },
}) => ({
  loadingBusiness,
  listaBusiness,
  pageSizeBusiness,
  messageBusiness,
});

const mapDispatchToProps = {
  getListaBusinessRequest: getListaBusiness.request,
  changePageSizeBusiness,
  loadEmptyBusiness,
  cleanMessageBusiness,
};

const columns = [
  {
    field: "name",
    headerName: "Name",
    flex: 1,
    sortable: false,
    renderHeader: renderHeader,
  },
  {
    field: "active",
    headerName: "Active Status",
    flex: 1,
    type: "boolean",
    sortable: false,
    renderHeader: renderHeader,
    renderCell: renderBoolean,
  },
  {
    field: "createDate",
    headerName: "Creation Date",
    flex: 1,
    sortable: false,
    renderHeader: renderHeader,
    renderCell: renderFormatedDate,
  },
  {
    field: "updateDate",
    headerName: "Update Date",
    flex: 1,
    sortable: false,
    renderHeader: renderHeader,
    renderCell: renderFormatedDate,
  },
];

export default connect(mapStateToProps, mapDispatchToProps)(BusinessList);
